module.exports = __webpack_public_path__ + "static/media/check-filled.78e4f5b6.svg";